import styled from 'styled-components/macro';

export const SkeletonWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 16px;
  border-radius: 24px;
  background-color: ${(props) => props.theme.colors.white};
  display: flex;
  flex-direction: column;
`;

export const GroupWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  background-color: ${(props) => props.theme.colors.white};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.gray[100]};
`;

export const MetersTitleWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 8px 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const MetersAvatarWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 8px;
`;

export const RowsColumn = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const MetersButtonsWrapper = styled.div<{ isMobile: boolean }>`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: ${(props) => (props.isMobile ? 'column' : 'row')};
  gap: ${(props) => (props.isMobile ? '8px' : '16px')};
`;
